import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import CommonTooltip from 'components/CommonTooltip'
import CheckIcon from 'assets/images/svg/exclude.svg'
import { colors } from 'theme'
export default function RegisterForm({
  password,
  open,
  children,
}: {
  password: string
  open?: boolean
  children: JSX.Element
}) {
  const theme = useTheme()
  const md = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <CommonTooltip
      width={md ? 280 : 300}
      placement={md ? 'bottom' : 'left'}
      title=""
      open={open}
      content={
        <Box component="div">
          {password.length >= 8 ? (
            <Typography marginBottom="8px" variant="body1" component="div" fontWeight="600" color={colors.white}>
              Minimum of 8 characters
              <img src={CheckIcon} alt="" style={{ marginLeft: '8px' }} />
            </Typography>
          ) : (
            <Typography marginBottom="8px" variant="body1" component="div">
              Minimum of 8 characters
            </Typography>
          )}
          {new RegExp('[a-z]').test(password) ? (
            <Typography marginBottom="8px" variant="body1" component="div" fontWeight="600" color={colors.white}>
              At least 1 lowercase letter
              <img src={CheckIcon} alt="" style={{ marginLeft: '8px' }} />
            </Typography>
          ) : (
            <Typography marginBottom="8px" variant="body1" component="div">
              At least 1 lowercase letter
            </Typography>
          )}
          {new RegExp('[A-Z]').test(password) ? (
            <Typography marginBottom="8px" variant="body1" component="div" fontWeight="600" color={colors.white}>
              At least 1 uppercase letter
              <img src={CheckIcon} alt="" style={{ marginLeft: '8px' }} />
            </Typography>
          ) : (
            <Typography marginBottom="8px" variant="body1" component="div">
              At least 1 uppercase letter
            </Typography>
          )}
          {new RegExp('[0-9]').test(password) ? (
            <Typography marginBottom="8px" variant="body1" component="div" fontWeight="600" color={colors.white}>
              At least 1 number
              <img src={CheckIcon} alt="" style={{ marginLeft: '8px' }} />
            </Typography>
          ) : (
            <Typography marginBottom="8px" variant="body1" component="div">
              At least 1 number
            </Typography>
          )}
        </Box>
      }
    >
      {children}
    </CommonTooltip>
  )
}
